if (!window.__activityFormAssetsReady) {
  const assetPromises = window.__activityFormAssetPromises || (window.__activityFormAssetPromises = {});
  const assets = [
    { src: "\/\/hotroborocbargains.com\/cdn\/shop\/t\/148\/assets\/RoInput.js?v=9671540383312282381790576641", component: 'ro-input' },
    { src: "\/\/hotroborocbargains.com\/cdn\/shop\/t\/148\/assets\/RoSelect.js?v=175623534981857522281791862891", component: 'ro-select' },
    { src: "\/\/hotroborocbargains.com\/cdn\/shop\/t\/148\/assets\/RoChoiceChips.js?v=40010114715389572991784860253", component: 'ro-choice-chips' },
    { src: "\/\/hotroborocbargains.com\/cdn\/shop\/t\/148\/assets\/RoCheckbox.js?v=100657354908828662051791862890", component: 'ro-checkbox' },
    { src: "\/\/hotroborocbargains.com\/cdn\/shop\/t\/148\/assets\/RoTextarea.js?v=87762728768011705691791862892", component: 'ro-textarea' },
    { src: "\/\/hotroborocbargains.com\/cdn\/shop\/t\/148\/assets\/RoDatePicker.js?v=57345819973731936501791862891", component: 'ro-date-picker' },
    { src: "\/\/hotroborocbargains.com\/cdn\/shop\/t\/148\/assets\/RoFileUpload.js?v=76501023751183491881791862891", component: 'ro-file-upload' },
    { src: "\/\/hotroborocbargains.com\/cdn\/shop\/t\/148\/assets\/RoToast.js?v=166085325754126541784788781", component: 'ro-toast', global: 'RoToast', module: true },
  ];

  function assetReady(asset) {
    if (asset.component && (!window.customElements || !customElements.get(asset.component))) return false;
    if (asset.global && typeof window[asset.global] === 'undefined') return false;
    return true;
  }

  function findExistingScript(src) {
    const absoluteSrc = new URL(src, document.baseURI).href;
    return Array.prototype.find.call(document.scripts, (script) => script.src === absoluteSrc);
  }

  function waitForScript(script, asset, resolve, reject) {
    const timeout = window.setTimeout(
      () => reject(new Error(`Timed out loading resource: ${asset.src}`)),
      15000,
    );
    script.addEventListener(
      'load',
      () => {
        window.clearTimeout(timeout);
        if (assetReady(asset)) resolve();
        else reject(new Error(`Resource loaded but component is unavailable: ${asset.src}`));
      },
      { once: true },
    );
    script.addEventListener(
      'error',
      () => {
        window.clearTimeout(timeout);
        reject(new Error(`Failed to load resource: ${asset.src}`));
      },
      { once: true },
    );
  }

  function loadAssetOnce(asset) {
    if (assetReady(asset)) return Promise.resolve();
    if (assetPromises[asset.src]) return assetPromises[asset.src];

    assetPromises[asset.src] = new Promise((resolve, reject) => {
      const existing = findExistingScript(asset.src);
      if (existing) {
        waitForScript(existing, asset, resolve, reject);
        return;
      }

      const script = document.createElement('script');
      script.src = asset.src;
      script.setAttribute('data-activity-form-asset', '');
      if (asset.module) script.type = 'module';
      else script.async = false;
      waitForScript(script, asset, resolve, reject);
      document.head.appendChild(script);
    });
    return assetPromises[asset.src];
  }

  window.__activityFormLoadAssetOnce = loadAssetOnce;
  window.__activityFormHeicAsset = {
    src: "\/\/hotroborocbargains.com\/cdn\/shop\/t\/148\/assets\/heic2any.min.js?v=90383926560294506831783584915",
    global: 'heic2any',
  };
  window.__activityFormAssetsReady = Promise.all(assets.map(loadAssetOnce));
}
